const FIRST_NAME = localStorage.getItem('first_name') && localStorage.getItem('first_name') != null ? localStorage.getItem('first_name') : 'FIRST_NAME';

const QUIZ_RESULT = {
    'level1':[
        {
            p1:`Not the results we know you’re capable of ${FIRST_NAME}`,
            p2:`Let’s give this quiz another try and see if we can do better.`
        }
    ],
    'level2':[
        {
            p1:`Oooh! Some good, some bad ${FIRST_NAME}`,
            p2:`Why not retry the quiz? I think you can do better.`
        }
    ],
    'level3':[
        {
            p1:`You’re nearly there ${FIRST_NAME}`,
            p2:`Just a few incorrect answers. These quizzes will help you on your poker journey. Why not try again and see if you can get full marks?`
        }
    ],
    'level4':[
        {
            p1:`So close to full marks ${FIRST_NAME}`,
            p2:`You got just one question wrong, so I can see you’re getting more comfortable with these situations. Good job!`
        }
    ],
    'level5PreFlop':[
        {
            p1:`Full marks! Great job ${FIRST_NAME}`,
            p2:`A perfect score. I’m impressed! You’re well on your way to perfecting your pre-flop strategy.`
        }
    ],
    'level5PostFlop':[
        {
            p1:`Full marks! Great job ${FIRST_NAME}`,
            p2:`A perfect score. I’m impressed! You’re well on your way to perfecting your post-flop strategy.`
        }
    ]    
}


const QUIZ_ANSWER_MESSAGES = {
    'possitive': [
        {
            p1: `Nice one ${FIRST_NAME}`,
            p2: 'Good job that was correct'
        },
        {
            p1: `Well done ${FIRST_NAME}`,
            p2: 'you got it right'
        },
        {
            p1: `Great job ${FIRST_NAME}`,
            p2: 'You\'re learning'
        },
        {
            p1: `Good answer ${FIRST_NAME}!`,
            p2: 'Keep up the good work'
        },
        {
            p1: 'Correct, Good job!',
            p2: 'You got it right'
        },
        {
            p1: `Nice one ${FIRST_NAME}`,
            p2: 'your on fire today!'
        },
        {
            p1: 'Aggressive I like it',
            p2: 'Keep it up!'
        }
    ],
    'negative_fold': [
        {
            p1: `Not this time ${FIRST_NAME}!`,
            p2: 'folding here was the wrong choice'
        },
        {
            p1: 'Incorrect',
            p2: 'folding here was a missed opportunity'
        },
        {
            p1: `Unlucky ${FIRST_NAME}`,
            p2: 'A Better choice was to stay in the hand'
        },
        {
            p1: 'Maybe next time',
            p2: 'A raise here was a better move'
        },
        {
            p1: 'Incorrect, its ok your learning!',
            p2: 'In this case, raising was a better choice'
        }
    ],
    'negative_raise': [
        {
            p1: 'A raise here is a bad idea',
            p2: 'the better option was to fold'
        },
        {
            p1: `Unlucky ${FIRST_NAME}`,
            p2: 'folding was better than raising there'
        },
        {
            p1: `Raising was the wrong move ${FIRST_NAME}`,
            p2: 'folding is not quitting!'
        },
        {
            p1: 'A fold here is better than a raise',
            p2: 'its ok were still learning!'
        },
        {
            p1: 'A raise there is risky!',
            p2: 'Better to play it safe and fold here'
        }
    ],
    'call': [
        {
            p1: `Less Calling ${FIRST_NAME}`,
            p2: 'we call this limping, raise or fold.'
        },
        {
            p1: 'C\'mon more aggression!',
            p2: `less calling and more raising ${FIRST_NAME}`
        },
        {
            p1: 'You\'re calling a lot',
            p2: 'Raise or fold, more aggression.'
        },
        {
            p1: 'Too much Calling!',
            p2: 'best to either raise or fold'
        },
        {
            p1: 'Don\'t Limp, either raise or fold',
            p2: 'Passive play is a poor strategy'
        },
        {
            p1: 'Raising over calling!',
            p2: 'It is better to raise in this position'
        },
        {
            p1: 'Try not to call too much',
            p2: 'this is passive play, raise or fold'
        }
    ]
}
const BIG_BLIND = [  {
    p1: "Always think about table position"
},
{
    p1: `Fold or Play, your choice ${FIRST_NAME}`
},
{
    p1: `This might be a tricky one`
}
]
const QUIZ_FACING_1_RAISER_MESSAGES = {
    '0': [
        {
            p1: 'Always think about table position',
            p2: 'Utilise position to your advantage'
        },
        {
            p1: 'Always think about table position',
            p2: 'Not a bad position to be'
        },
        {
            p1: 'Always think about table position',
            p2: 'The button has its advantages'
        }
    ],
    '8': [
        {
            p1: 'What’s the best move',
            p2: 'One on One, what\'s your move?'
        },
        {
            p1: 'What’s the best move',
            p2: 'Big blind, what\'s your move?'
        },
        {
            p1: 'What’s the best move',
            p2: 'Remember you are the big blind'
        },
        {
            p1: 'This is a tricky one',
            p2: 'Have a think about this one'
        },
        {
            p1: 'This is a tricky one',
            p2: 'This one may be a little difficult'
        },
        {
            p1: 'This is a tricky one',
            p2: 'They can’t all be easy David!'
        }
    ],
    '9':BIG_BLIND,
    'last': [
        {
            p1: 'Last one give it your best shot',
            p2: 'Almost there just one more',
        },
        {
            p1: 'Last one give it your best shot',
            p2: 'Almost there just one more',
        },
        {
            p1: 'Last one give it your best shot',
            p2: 'Almost there just one more',
        }
    ]
}
const EARLY_POSITION_MESSAGE_ARRAY = [
    {
        p1: 'Do you fold, call or raise?',
    },
    {
        p1: 'In Early position',
        p2: 'Be conservative with your play'
    },
    {
        p1: 'Play tighter in early position',
    },
    {
        p1: 'Be mindful',
        p2: 'you\'re one of the first to act'
    },
    {
        p1: 'Tight it good',
        p2: 'Especially when in early position.'
    },
    {
        p1: 'Another one in early position'
    },
    {
        p1: 'This is tricky one'
    },
    {
        p1: 'Control Position',
        p2: 'Position play is a poker fundamental'
    },
    {
        p1: 'What do we think of this hand?'
    }
]
const LATE_POSIOTN_MESSAGES_ARRAY = [
    {
        p1: 'Your now playing in late position!',
    },
    {
        p1: 'Late position means play a bit more loose',
    },
    {
        p1: 'Late position is good',
        p2: 'You have more information'
    },

]


const QUIZ_COMMON_MESSAGES = {
    '3': EARLY_POSITION_MESSAGE_ARRAY,
    '2': EARLY_POSITION_MESSAGE_ARRAY,
    '0': LATE_POSIOTN_MESSAGES_ARRAY,
    '1': LATE_POSIOTN_MESSAGES_ARRAY,
    '9': BIG_BLIND,
    'last': [
        {
            p1: 'Last hand',
            p2: 'Make it a good one'
        },
        {
            p1: 'Last one now'
        }
    ]
}

const QUIZ_C_BET_VS_BTN = {
    '8': [
        {
            p1: "Always think about table position"
        },
        {
            p1: `What's your move ${FIRST_NAME}?`
        },
        {
            p1: "A C bet indicates , you like your hand"
        },
        {
            p1: "To Play or not to play"
        },
        {
            p1: "Use table information to guide decisions"
        },
        {
            p1: `Fold or Play, your choice ${FIRST_NAME}`
        },
        {
            p1: `This might be a tricky one`
        },
        {
            p1: `Continue with the hand or fold?`
        },
        {
            p1: `A C bet is taking the Initiative`
        }
    ],
    'last': [
        {
            p1: 'Last one give it your best shot'
        }
    ]

}
const QUIZ_COMMON_MESSAGES_BY_TYPE = {
    'Facing an Unopened pot': { ...QUIZ_COMMON_MESSAGES },
    'Facing 1 Raiser': { ...QUIZ_FACING_1_RAISER_MESSAGES },
    'C-Bet BB vs BTN': { ...QUIZ_C_BET_VS_BTN }
}
export { QUIZ_ANSWER_MESSAGES, QUIZ_COMMON_MESSAGES_BY_TYPE, QUIZ_RESULT}


/** WEBPACK FOOTER **
 ** ./src/components/LandingPage/QuizMessages.js
 **/